import React from "react"
import { Link as LinkRouter } from "react-router-dom"

import { Tooltip, Box } from "@material-ui/core"
import { TitleLink } from "@/pages/Admin/TrackableLinks/TrackableLinksTable"

import useStyles from "@/pages/Admin/TrackableLinks/TrackableLinksTable/TrackableLinkTitleOnTable/styles"

type TrackableLinkTitleOnTableProps = {
	titleLink: TitleLink
}

const TrackableLinkTitleOnTable: React.FC<TrackableLinkTitleOnTableProps> = (props) => {
	const { titleLink } = props
	const classes = useStyles()

	return (
		<Box className={classes.boxContainer}>
			<Tooltip title={titleLink.text}>
				<LinkRouter className={classes.trackableTitleLink} to={titleLink.link}>
					{titleLink.text}
				</LinkRouter>
			</Tooltip>
		</Box>
	)
}

export default TrackableLinkTitleOnTable
